export default __webpack_public_path__ + "static/pg7Vp3Img-e3bf939aec0f8926648e13b905ee81a5.png";